import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
// resources
import DepartmentResource from '../../resources/department'

// mixin
import toastMixin from '../../mixins/toast'

import departmentGridColumns from './departmentGridColumns'

export default Vue.extend({
    data() {
        return {
            departmentColumnDefs: [],
            departmentRowData: [],
        }
    },
    props: ['entityId'],
    mixins: [toastMixin],
    methods: {
        async fetchDepartmentInfo(entityId) {
            try {
                this.departmentRowData = await DepartmentResource.all({ entity_id: entityId })
            } catch (error) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Network Error', 'Error getting Users')
            }
        },
    },
    components: {
        AgGridVue,
    },
    watch: {
        entityId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchDepartmentInfo(newVal)
            }
        },
    },
    async mounted() {
        if (this.entityId) {
            this.fetchDepartmentInfo(this.entityId)
        } else {
            const departmentResource = await DepartmentResource.list()
            this.departmentRowData = departmentResource.resources
        }
        this.departmentColumnDefs = departmentGridColumns
    },
})
